import { render, staticRenderFns } from "./IosWheelPicker.vue?vue&type=template&id=620000c6&scoped=true"
import script from "./IosWheelPicker.vue?vue&type=script&lang=js"
export * from "./IosWheelPicker.vue?vue&type=script&lang=js"
import style0 from "./IosWheelPicker.vue?vue&type=style&index=0&id=620000c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620000c6",
  null
  
)

export default component.exports